/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EditCommentFormContainer_comment = {
    readonly id: string;
    readonly body: string | null;
    readonly createdAt: string;
    readonly revision: {
        readonly id: string;
        readonly media: ({
            readonly __typename: "GiphyMedia";
            readonly url: string;
            readonly title: string | null;
            readonly width: number | null;
            readonly height: number | null;
            readonly still: string;
            readonly video: string;
        } | {
            readonly __typename: "TenorMedia";
            readonly url: string;
            readonly title: string | null;
        } | {
            readonly __typename: "TwitterMedia";
            readonly url: string;
            readonly width: number | null;
        } | {
            readonly __typename: "BlueskyMedia";
            readonly url: string;
            readonly width: number | null;
        } | {
            readonly __typename: "YouTubeMedia";
            readonly url: string;
            readonly width: number | null;
            readonly height: number | null;
        } | {
            readonly __typename: "ExternalMedia";
            readonly url: string;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
    } | null;
    readonly author: {
        readonly username: string | null;
    } | null;
    readonly editing: {
        readonly editableUntil: string | null;
    };
    readonly site: {
        readonly id: string;
    };
    readonly " $refType": "EditCommentFormContainer_comment";
};
export type EditCommentFormContainer_comment$data = EditCommentFormContainer_comment;
export type EditCommentFormContainer_comment$key = {
    readonly " $data"?: EditCommentFormContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"EditCommentFormContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v5 = [
        (v1 /*: any*/),
        (v3 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "EditCommentFormContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentRevision",
                "kind": "LinkedField",
                "name": "revision",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v1 /*: any*/),
                                    (v2 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "still",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "video",
                                        "storageKey": null
                                    }
                                ],
                                "type": "GiphyMedia",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v1 /*: any*/),
                                    (v2 /*: any*/)
                                ],
                                "type": "TenorMedia",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": (v5 /*: any*/),
                                "type": "TwitterMedia",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": (v5 /*: any*/),
                                "type": "BlueskyMedia",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v1 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/)
                                ],
                                "type": "YouTubeMedia",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v1 /*: any*/)
                                ],
                                "type": "ExternalMedia",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "username",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EditInfo",
                "kind": "LinkedField",
                "name": "editing",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "editableUntil",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "site",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'df15593a769ce1aaa364731fda228a1c';
export default node;
